import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { EBinderContractTab } from './types';

interface BinderContractTabsProps {
  activeTab: string;
  setActiveTab: (key: EBinderContractTab) => void;
}

const BinderContractTabs: React.FC<BinderContractTabsProps> = ({
  activeTab,
  setActiveTab,
}) => {
  const { t } = useTranslation();
  const binderContractTabs = [
    {
      key: EBinderContractTab.ALL_CONTRACT,
      label: (
        <span className="flex gap-2 items-center">
          {t('binderContract.allContract')}
        </span>
      ),
    },
    {
      key: EBinderContractTab.MY_CONTRACT,
      label: (
        <span className="flex gap-2 items-center">
          {t('binderContract.myContract')}
        </span>
      ),
    },
    // {
    //   key: EBinderContractTab.CURRENT_YEAR,
    //   label: (
    //     <span className="flex gap-2 items-center">
    //       {t('binderContract.currentYear')}
    //     </span>
    //   ),
    // },
  ];

  return (
    <div className="bg-[#E3F2FB] rounded-xl w-fit mb-3">
      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as EBinderContractTab)}
        items={binderContractTabs}
        className="custom-tabs uw-custom-tabs ant-tabs-tab"
        tabBarGutter={8}
        tabBarStyle={{ margin: 0 }}
      />
    </div>
  );
};

export default BinderContractTabs;
